import { render, staticRenderFns } from "./ReleaseDownloadDialog.vue?vue&type=template&id=456a2c1c&scoped=true"
import script from "./ReleaseDownloadDialog.vue?vue&type=script&lang=js"
export * from "./ReleaseDownloadDialog.vue?vue&type=script&lang=js"
import style0 from "./ReleaseDownloadDialog.vue?vue&type=style&index=0&id=456a2c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a2c1c",
  null
  
)

export default component.exports